
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Why Choose Cofunnels?
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We're not just another funnel building service. We're your growth partners, dedicated to creating funnels that don't just look good – they convert like crazy.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-trophy-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Proven Track Record</h3>
                  <p className="text-gray-600">Over $50M generated for our clients with 500+ five-star reviews on Fiverr and other platforms.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-lightbulb-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Conversion-Focused</h3>
                  <p className="text-gray-600">Every element is designed with conversion in mind, using psychology and data-driven insights.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-rocket-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Fast Delivery</h3>
                  <p className="text-gray-600">Most funnels delivered within 3-7 days without compromising on quality or performance.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20team%20of%20funnel%20experts%20working%20on%20conversion%20optimization%2C%20modern%20office%20environment%20with%20multiple%20monitors%20showing%20sales%20funnels%2C%20collaborative%20workspace%2C%20marketing%20professionals%20analyzing%20data%2C%20clean%20contemporary%20design%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=600&height=400&seq=about-team-001&orientation=landscape"
              alt="Cofunnels Team"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
            />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/20 to-transparent"></div>
            
            {/* Stats overlay */}
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-2xl font-bold text-gray-900">500+</div>
                    <div className="text-xs text-gray-600">Happy Clients</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">$50M+</div>
                    <div className="text-xs text-gray-600">Revenue Generated</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">98%</div>
                    <div className="text-xs text-gray-600">Success Rate</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
